<div class="square-card" tabindex="0" (keypress)="enterItemByKeyboard($event)"
         [ngClass]="{'pinned':item.pinnedTime}"
         (click)="showDetails()">

    <div class="square-image">
        <!--<img [src]="imageService.safeImage(imageService.imageSourceUrl(item.cover?.source))" class="image"-->
             <!--[class.promotion]="item.isPromotionImage" />-->
        <ig-image [imageUrl]="item.cover?.source" [placeCategoryList]="item.categoryList" [class.promotion]="item.isPromotionImage" [alt]="item.title||item.name"></ig-image>
        <div *ngIf="!item.isPromotionImage" class="ig-title">
            <p>{{item.title||item.name}}</p>
        </div>
        <div class="choice" *ngIf="item.isChoice">
            <mat-icon>favorite</mat-icon>
            <span>{{editorChoiceText}}</span>
        </div>
    </div>

    <div *ngIf="item.startTime&&!item.isPromotionImage" class="align-center">
        <div class="square-time" *ngIf="item.eventTimes&&item.eventTimes.length<=1">
            <mat-icon>date_range</mat-icon>
            <!--<span *ngIf="!item.startTimeText">{{item.startTimeFormatted}}{{item.endTimeFormatted?' - '+item.endTimeFormatted:''}}</span>-->
            <!--<span *ngIf="item.startTimeText">{{item.startTimeText+item.timezone}}{{item.endTimeText?' - '+item.endTimeText+item.timezone:''}}</span>-->
            <span [class.small-time-text]="eventTimeText.length>41">{{eventTimeText}}</span>
        </div>

        <div class="square-time" *ngIf="item.eventTimes&&item.eventTimes.length>1">
            <mat-icon>date_range</mat-icon>
            <span>Multiple Dates Event - See Details</span>
        </div>
    </div>

    <div *ngIf="!item.startTime&&!item.isPromotionImage" class="align-center">
        <div category class="square-time" [matTooltip]="item.category">
            <mat-icon>list</mat-icon>
            <span>{{placeCategory}}</span>
        </div>
    </div>

    <div *ngIf="!item.isPromotionImage" class="detail-btn-wrap" role="button">
        details
    </div>

</div>



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/square.card/visitor.square.card.component.html